var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserfriendly(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 42,
    height: 42,
    rx: 21,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_437_31795)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_437_31795)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 10.2812C22.4533 10.2812 22.8203 9.91425 22.8203 9.46094V7.82031C22.8203 7.367 22.4533 7 22 7C21.5467 7 21.1797 7.367 21.1797 7.82031V9.46094C21.1797 9.91425 21.5467 10.2812 22 10.2812Z",
    fill: "#00994E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8612 11.6815L27.5019 10.0409C27.8223 9.72049 27.8223 9.20139 27.5019 8.88095C27.1814 8.56052 26.6623 8.56052 26.3419 8.88095L24.7013 10.5216C24.3808 10.842 24.3808 11.3611 24.7013 11.6815C25.0217 12.002 25.5408 12.002 25.8612 11.6815Z",
    fill: "#00994E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1388 11.6815C18.4592 12.002 18.9783 12.002 19.2987 11.6815C19.6192 11.3611 19.6192 10.842 19.2987 10.5216L17.6581 8.88095C17.3377 8.56052 16.8186 8.56052 16.4981 8.88095C16.1777 9.20139 16.1777 9.72049 16.4981 10.0409L18.1388 11.6815Z",
    fill: "#00994E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3828 18.5938C15.3828 16.7841 13.9112 15.3125 12.1016 15.3125C10.292 15.3125 8.82031 16.7841 8.82031 18.5938C8.82031 20.4034 10.292 21.875 12.1016 21.875C13.9112 21.875 15.3828 20.4034 15.3828 18.5938Z",
    fill: "#00994E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 13.6172C20.6431 13.6172 19.5391 14.7212 19.5391 16.0781C19.5391 19.244 16.9081 21.875 13.7422 21.875H12.1016C9.84015 21.875 8 23.7151 8 25.9766V34.1797C8 34.633 8.367 35 8.82031 35H15.3828C15.8355 35 16.1922 34.633 16.1922 34.1805L16.1969 26.5093C20.9874 25.3806 24.4609 21.0673 24.4609 16.0781C24.4609 14.7212 23.3569 13.6172 22 13.6172Z",
    fill: "#00994E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1797 18.5938C35.1797 16.7841 33.708 15.3125 31.8984 15.3125C30.0888 15.3125 28.6172 16.7841 28.6172 18.5938C28.6172 20.4034 30.0888 21.875 31.8984 21.875C33.708 21.875 35.1797 20.4034 35.1797 18.5938Z",
    fill: "#00994E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.898 21.875H30.2574C28.3711 21.875 26.654 20.8938 25.6066 19.4848C25.1266 21.1784 24.2904 22.7154 23.1738 24.0315C24.4818 25.1862 26.0981 26.1026 27.8024 26.5085L27.8073 34.1805C27.8073 34.633 28.1641 35 28.6167 35H35.1792C35.6325 35 35.9995 34.633 35.9995 34.1797V25.9766C35.9995 23.7151 34.1594 21.875 31.898 21.875Z",
    fill: "#00994E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_437_31795"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(7.5 7)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_437_31795"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(8 7)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserfriendly);
export default __webpack_public_path__ + "static/media/userfriendly.9127ebd28a1adf9bba271262b93d49d4.svg";
export { ForwardRef as ReactComponent };